
<template>
  <div id="page-user-view">

    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.id }} not found. </span>
    </vs-alert>

    <div id="user-data" v-if="employeeIdentification">

      <vx-card  class="mb-base" icon-pack="feather" >
          <div class="vx-col w-full">
                    <div class="flex items-end px-3 text-primary">
                        <feather-icon svgClasses="w-6 h-6" icon="ClipboardIcon" class="mr-2" />
                        <span class="font-medium text-xl leading-none text-primary">Employee Identification</span>
                    </div>
                    <vs-divider />
             </div>
        <!-- Avatar -->
        <div class="vx-row">

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Branch<span style="color:red">*</span> :</td>
                <td v-if="isEdit"> <v-select v-validate="'required'" name="branch" v-model="branchName" label="branchName" :options="getAllBranchLookup" placeholder="Please Select" />
                    <span class="text-danger text-sm" v-show="errors.has('branch')">{{ errors.first('branch') }}</span>
                </td>
                <td v-else>{{ branchName.branchName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Position<span style="color:red">*</span> :</td>
                <td v-if="isEdit"> <v-select v-validate="'required'" name="position" v-model="positionName" label="positionName" :options="getAllPositionLookup" placeholder="Please Select" />
                    <span class="text-danger text-sm" v-show="errors.has('position')">{{ errors.first('position') }}</span>
                </td>
                <td v-else>{{ positionName.positionName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Department<span style="color:red">*</span> :</td>
                <td v-if="isEdit"> <v-select v-validate="'required'" name="department" v-model="departmentName" label="departmentName" :options="getAllDepartmentLookup" placeholder="Please Select" />
                    <span class="text-danger text-sm" v-show="errors.has('department')">{{ errors.first('department') }}</span>
                </td>
                <td v-else>{{ departmentName.departmentName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Division<span style="color:red">*</span> :</td>
                <td v-if="isEdit"> <v-select v-validate="'required'" name="division" v-model="divisionName" label="divisionName" :options="getAllDivisionLookup" placeholder="Please Select" />
                    <span class="text-danger text-sm" v-show="errors.has('division')">{{ errors.first('division') }}</span>
                </td>
                <td v-else>{{ divisionName.divisionName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Section<span style="color:red">*</span> :</td>
                <td v-if="isEdit"> <v-select v-validate="'required'" name="section" v-model="sectionName" label="sectionName" :options="getAllSectionLookup" placeholder="Please Select" />
                    <span class="text-danger text-sm" v-show="errors.has('section')">{{ errors.first('section') }}</span>
                </td>
                <td v-else>{{ sectionName.sectionName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Emp Category<span style="color:red">*</span> :</td>
                <td v-if="isEdit"> <v-select v-validate="'required'" name="employee category" v-model="employeeCategoryName" label="employeeCategoryName" :options="getAllEmployeeCategoryLookup" placeholder="Please Select" />
                    <span class="text-danger text-sm" v-show="errors.has('employee category')">{{ errors.first('employee category') }}</span>
                </td>
                <td v-else>{{ employeeCategoryName.employeeCategoryName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Civil Status<span style="color:red">*</span> :</td>
                <td v-if="isEdit"> <v-select  v-validate="'required'" name="civil status" v-model="civilStatusName" label="civilStatusName" :options="getAllCivilStatusLookup" placeholder="Please Select" />
                    <span class="text-danger text-sm" v-show="errors.has('civil status')">{{ errors.first('civil status') }}</span>
                </td>
                <td v-else>{{ civilStatusName.civilStatusName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Nationality<span style="color:red">*</span> :</td>
                <td v-if="isEdit"> <v-select  v-validate="'required'" name="nationality" v-model="nationalityName" label="nationalityName" :options="getAllNationalityLookup" placeholder="Please Select" />
                    <span class="text-danger text-sm" v-show="errors.has('nationality')">{{ errors.first('nationality') }}</span>
                </td>
                <td v-else>{{ nationalityName.nationalityName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Religion<span style="color:red">*</span> :</td>
                <td v-if="isEdit"> <v-select v-validate="'required'" name="religion" v-model="religionName" label="religionName" :options="getAllReligionLookup" placeholder="Please Select" />
                    <span class="text-danger text-sm" v-show="errors.has('religion')">{{ errors.first('religion') }}</span>
                </td>
                <td v-else>{{ religionName.religionName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Relative Employed :</td>
                <td v-if="isEdit"> <v-select v-model="relativeName" label="fullName" :options="getAllEmployee" placeholder="Please Select" /></td>
                <td v-else>{{ relativeName != null ? relativeName.fullName : ''}}</td>
              </tr>
              <tr>
                <td class="font-semibold ">Immediate Supervisor<span style="color:red">*</span> :</td>
                <td v-if="isEdit"> 
                    <v-select v-validate="'required'" name="immediate supervisor" v-model="immediateSupervisor" label="fullName"  :options="getAllEmployee" placeholder="Please Select" />
                    <span class="text-danger text-sm" v-show="errors.has('immediate supervisor')">{{ errors.first('immediate supervisor') }}</span>
                </td>
                <td v-else>{{ immediateSupervisor.fullName }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>  
              <tr>
                <td class="font-semibold ">Referred By :</td>
                <td v-if="isEdit"> <vs-input v-model="employeeIdentification.referredby" placeholder="Referred by" /></td>
                <td v-else>{{ employeeIdentification.referredby }}</td>
              </tr>
              <tr>
                <td class="font-semibold ">Applied Before :</td>
                <td><vs-checkbox v-model="employeeIdentification.appliedBefore" class="mr-4 mb-2" :disabled="!isEdit"/></td>
              </tr>
              
              <tr>
                <td class="font-semibold">Accept Field Work :</td>
                <td><vs-checkbox v-model="employeeIdentification.acceptFieldWork" class="mr-4 mb-2" :disabled="!isEdit"></vs-checkbox></td>
              </tr>
              <tr>
                <td class="font-semibold">Accused Crime :</td>
                <td v-if="isEdit"> <vs-input v-model="employeeIdentification.accusedCrime" placeholder="Accused of any Crime" /></td>
                <td v-else>{{ employeeIdentification.accusedCrime }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Illness :</td>
                <td v-if="isEdit"> <vs-input v-model="employeeIdentification.illness" placeholder="illness" /></td>
                <td v-else>{{ employeeIdentification.illness }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Physical Condition :</td>
                <td v-if="isEdit"> <vs-input v-model="employeeIdentification.physicalCondition" placeholder="Any Physical Condition" /></td>
                <td v-else>{{ employeeIdentification.physicalCondition }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Skills/Hobbies :</td>
                <td v-if="isEdit"> <vs-input v-model="employeeIdentification.skillsHobbies" placeholder="Skills & Hobbies" /></td>
                <td v-else>{{ employeeIdentification.skillsHobbies }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Enjoy Most :</td>
                <td v-if="isEdit"> <vs-input v-model="employeeIdentification.enjoyMost" placeholder="What you enjoy most" /></td>
                <td v-else>{{ employeeIdentification.enjoyMost }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Emergency to Notify :</td>
                <td v-if="isEdit"> <vs-input v-model="employeeIdentification.emergencyNotify" placeholder="Emergency Contact Person" /></td>
                <td v-else>{{ employeeIdentification.emergencyNotify }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Emergency Contact No :</td>
                <td v-if="isEdit"> <vs-input v-model="employeeIdentification.contactNo" placeholder="Emergency Contact No." /></td>
                <td v-else>{{ employeeIdentification.contactNo }}</td>
              </tr>
              <tr>
                <td class="font-semibold ">Relationship :</td>
                <td v-if="isEdit"> <v-select v-model="relationshipName" label="relationshipName" :options="getAllRelationshipLookup" placeholder="Please Select" /></td>
                <td v-else>{{ relationshipName.relationshipName }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button v-if="!isEdit" @click="EditInfo(employeeIdentification.id)" icon-pack="feather" icon="icon-edit" class="mr-4">Edit</vs-button>
            <vs-button v-else @click.prevent="SaveInfo()"  icon-pack="feather" icon="icon-edit" class="mr-4">Save</vs-button>
            <vs-button v-if="isEdit" @click="Cancel()" type="border" color="danger" icon-pack="feather" icon="icon-trash">Cancel</vs-button>
          </div>

        </div>

      </vx-card>


    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    created() {
        this.$vs.loading()
        this.userId = this.$route.params.id
        const data = {
            pageNumber: -1,
            pageSize: -1
        }
        this.$store.dispatch('lookup/getAllSection').catch(err => { console.log(err) })
        this.$store.dispatch('hrms/getAllEmployee', data).catch(err => { console.log(err) })
        this.$store.dispatch('lookup/getAllDepartment').catch(err => { console.log(err) })
        this.$store.dispatch('lookup/getAllBranch').catch(err => { consolelogr(err) })
        this.$store.dispatch('lookup/getAllDivision').catch(err => { console.log(err) })
        this.$store.dispatch('lookup/getAllPosition').catch(err => { console.log(err) })
        this.$store.dispatch('lookup/getAllEmployeeCategory').catch(err => { consolelogr(err) })
        this.$store.dispatch('lookup/getAllCivilStatus').catch(err => { console.log(err) })
        this.$store.dispatch('lookup/getAllNationality').catch(err => { console.log(err) })
        this.$store.dispatch('lookup/getAllReligion').catch(err => { console.log(err) })
        this.$store.dispatch('lookup/getAllRelationshipLookup').catch(err => { console.log(err) })
          
        
        
        this.$store.dispatch('hrms/getAllIdentification', this.userId)
                  .then((res) => {
                    this.$vs.loading.close()
                    this.employeeIdentification = JSON.parse(JSON.stringify(res.data.data))
                    console.log(this.employeeIdentification)
                  })
                  .catch(() => {
                    this.$vs.loading.close()
                    this.user_not_found = true
                  })
    },
    computed: {
       getAllEmployee(){
         console.log(this.$store.state.hrms.allEmployee)
         return this.$store.state.hrms.allEmployee
       },
       getAllDepartmentLookup() {
          return this.$store.state.lookup.getAllDepartment
       },
       getAllBranchLookup() {
         return this.$store.state.lookup.getAllBranch
       },
       getAllPositionLookup() {
         return this.$store.state.lookup.getAllPosition
       },
       getAllDivisionLookup() {
         return this.$store.state.lookup.getAllDivision
       },
       getAllSectionLookup() {
         return this.$store.state.lookup.getAllSection
       },
       getAllEmployeeCategoryLookup() {
         return this.$store.state.lookup.getAllEmployeeCategory
       },
       getAllCivilStatusLookup() {
         return this.$store.state.lookup.getAllCivilStatus
       },
       getAllNationalityLookup() {
         return this.$store.state.lookup.getAllNationality
       },
       getAllReligionLookup() {
         return this.$store.state.lookup.getAllReligion
       },
       getAllRelationshipLookup() {
         return this.$store.state.lookup.getAllRelationshipLookup
       },
      departmentName: {
        get() { return this.$store.getters['lookup/department'](this.employeeIdentification.departmentId) },
        set(obj) { this.employeeIdentification.departmentId = obj.departmentId}
      },
      branchName: {
        get() { return this.$store.getters['lookup/branch'](this.employeeIdentification.branchId) },
        set(obj) { this.employeeIdentification.branchId = obj.branchId }
      },
      positionName: {
        get() { return this.$store.getters['lookup/position'](this.employeeIdentification.positionId) },
        set(obj) { this.employeeIdentification.positionId = obj.positionId }
              },
      divisionName: {
        get() { return this.$store.getters['lookup/division'](this.employeeIdentification.divisionId) },        
        set(obj) { this.employeeIdentification.divisionId = obj.divisionId}
      },
      sectionName:  {
        get() { return this.$store.getters['lookup/section'](this.employeeIdentification.sectionId) },
        set(obj) { this.employeeIdentification.sectionId = obj.sectionId}
      },
      employeeCategoryName:  {
        get() { return this.$store.getters['lookup/employeeCategory'](this.employeeIdentification.employeeCategoryId) },
        set(obj) { this.employeeIdentification.employeeCategoryId = obj.employeeCategoryId }
      },
      civilStatusName:  {
        get() { return this.$store.getters['lookup/civilStatus'](this.employeeIdentification.civilStatusId) },
        set(obj) { this.employeeIdentification.civilStatusId = obj.civilStatusId }
      },
      nationalityName:  {
        get() { return this.$store.getters['lookup/nationality'](this.employeeIdentification.nationalityId) },
        set(obj) { this.employeeIdentification.nationalityId = obj.nationalityId }
      },
      religionName:  {
        get() { return this.$store.getters['lookup/religion'](this.employeeIdentification.religionId) },
        set(obj) { this.employeeIdentification.religionId = obj.religionId }
      },
      relationshipName:  {
        get() { return this.$store.getters['lookup/relationshipLookup'](this.employeeIdentification.relationshipId) },
        set(obj) { this.employeeIdentification.relationshipId = obj.relationshipId }
      },
      immediateSupervisor: {
        get() { return this.$store.getters['hrms/getEmployeeByUserId'](this.employeeIdentification.immediateSupervisorId.toLowerCase()) },
        set(obj) { this.employeeIdentification.immediateSupervisorId = obj.id }
      },
      relativeName: {
        get() { return this.$store.getters['hrms/getEmployeeByUserId'](this.employeeIdentification.relativeEmployed) },
        set(obj) { this.employeeIdentification.relativeEmployed = obj.id}
      }

    },
    data() {
        return {
            userId: null,
            user_not_found: false,
            employeeIdentification: null,

            isEdit: false,
          

            
        }
    },
    methods: {
      
      EditInfo() {
        this.isEdit = true
      },
      SaveInfo() {
        this.$validator.validateAll().then(result => {
          if (result) {
            // if form have no errors
            this.$vs.loading()
            this.isEdit = false
         
            //console.log(data)
            this.$store.dispatch('hrms/UpdateIdentification', this.employeeIdentification)
                .then((response) =>{
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Employee Identification Updated',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
          } else {
            // form have errors
              this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
          }
        })
         
      },
      Cancel() {
        this.isEdit = false
      },
      titleCase(str) {
        if(str != nul)
          return str
              .split(' ')
              .map((word) => word[0].toUpperCase() + word.slice(1).toLowerCase())
              .join(' ');
      }
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
    }
    
}
</script>